// extracted by mini-css-extract-plugin
export default {"campusContainer":"Campus_campusContainer__ZQh27","campusFeatures":"Campus_campusFeatures__q-RyP","campusFeature":"Campus_campusFeature__L+7Fa","campusMap":"Campus_campusMap__b0ge0"};